module.exports = __webpack_public_path__ + "static/media/close-modal.b75f27c8.svg";